import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import { TBaseRequest } from '~/store/types.ts';
import { TStatusVerify } from '~/store/remote-banking-contacts/types.ts';

export const verifyContrAgentRemoteBankingContacts = createAsyncThunk<null, TBaseRequest>(
  'remoteBankingContacts/verifyContrAgent',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const { data } = await api.post(
        `/remote-banking-contacts/applications/${applicationId}/verify-contragent`,
        null,
        { headers }
      );
      return data;
    } catch (error: unknown) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const statusVerifyContrAgent = createAsyncThunk<TStatusVerify, TBaseRequest>(
  'remoteBankingContacts/statusVerify',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const { data } = await api.get(
        `/remote-banking-contacts/applications/${applicationId}/status`,
        { headers }
      );
      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
